import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CmsService, RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { CustomAddToCartService } from '../../custom-add-to-cart.service';

@Component({
    selector: 'app-empty-cart',
    templateUrl: './empty-cart.component.html',
    styleUrls: ['./empty-cart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmptyCartComponent implements OnInit, OnDestroy {
  @Input() compName;
  cmsResponse: any;
  emptycontent: any;
  userAccountgetData: any;
  sessionStorage = sessionStorage;
  private subscriptions = new Subscription();

  constructor(
    private readonly route: RoutingService,
    private readonly cmsData: CmsService,
    private readonly addToCart: CustomAddToCartService,
    private readonly user: UserAccountFacade,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.user.get().subscribe((res) => {
        if (res) {
          this.userAccountgetData = res;
        }
        this.cdr.detectChanges();
      })
    );
    this.addToCart.getAllCarts(this.userAccountgetData?.userName);
    this.subscriptions.add(
      this.cmsData.getComponentData(this.compName).subscribe((res) => {
        this.cmsResponse = res;
        this.cdr.detectChanges();
      })
    );
    if (this.cmsResponse && this.cmsResponse.content) {
      this.emptycontent = this.cmsResponse.content;
    }
  }
  navigateToPdp() {
    this.route.goByUrl('/Open-Catalogue/c/1');
  }

  navigateToSavedOrder() {
    this.route.goByUrl('/cart/save');
  }
  navigateToFlu() {
    this.route.goByUrl('/influenza/dashboard');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
